/**
 * Lazy-load below-the-fold homepage assets (knock / spotlight)
 * only when their sections approach the viewport.
 */
(function () {
  function loadScript(src) {
    if (!src) return;
    if (document.querySelector('script[data-ac-lazy-src="' + src + '"]')) return;
    var s = document.createElement('script');
    s.src = src;
    s.defer = true;
    s.setAttribute('data-ac-lazy-src', src);
    document.head.appendChild(s);
  }

  function whenNear(el, cb, margin) {
    if (!el || typeof cb !== 'function') return;
    if (typeof IntersectionObserver === 'undefined') {
      cb();
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        if (!entries.some(function (e) {
          return e.isIntersecting;
        }))
          return;
        io.disconnect();
        cb();
      },
      { rootMargin: margin || '480px 0px' }
    );
    io.observe(el);
  }

  function boot() {
    var knockCfg = document.getElementById('AcLazyKnock');
    var knockSrc = knockCfg && knockCfg.textContent ? JSON.parse(knockCfg.textContent).src : '';
    var spotCfg = document.getElementById('AcLazySpotlight');
    var spotSrc = spotCfg && spotCfg.textContent ? JSON.parse(spotCfg.textContent).src : '';

    whenNear(document.getElementById('shop-collections') || document.querySelector('.auracase-collections'), function () {
      loadScript(knockSrc);
    });

    whenNear(document.querySelector('.auracase-spotlight'), function () {
      loadScript(knockSrc);
      loadScript(spotSrc);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
